// Tiny id generator for demo-mode entities created at runtime (new hashers,
// kennels, trails, payments…). Seed rows use stable hand-written ids so a
// visitor's selected identity survives a reseed; only rows minted in-session
// need a fresh id, and uniqueness only has to hold within one browser.

let counter = Date.now();

export function genId(prefix: string): string {
  counter += 1;
  return `${prefix}_${counter.toString(36)}`;
}
